var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('canvas',{attrs:{"id":_vm.cctv._id}})])}
var staticRenderFns = []

export { render, staticRenderFns }